import { Input, InputProps, InputWrapperBaseProps } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";
import InputWrapper from "../Form/Input";
import IMaskInputWrapper from "../Form/IMaskInputWrapper";
import { useTranslation } from "react-i18next";

interface IProps extends InputProps {
  name: string;
  label: string;
  placeholder: string;
  mask: string;
  inputWrapperProps?: InputWrapperBaseProps;
  withAsterisk?: boolean;
}
export default function IMaskInputControlled({
  name,
  label,
  placeholder,
  mask,
  inputWrapperProps,
  withAsterisk = false,
  ...props
}: IProps) {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <InputWrapper
          label={label}
          error={!!error?.message ? t(error.message) : ""}
          withAsterisk={withAsterisk}
          {...inputWrapperProps}
        >
          <Input<any>
            component={IMaskInputWrapper}
            mask={mask}
            placeholder={placeholder}
            error={!!error?.message ? t(error.message) : ""}
            {...props}
            {...field}
          />
        </InputWrapper>
      )}
    />
  );
}
